var map = {
	"../pages/account/account.module": [
		869,
		89
	],
	"../pages/add-member-chatroom/add-member-chatroom.module": [
		870,
		88
	],
	"../pages/add-member/add-member.module": [
		871,
		87
	],
	"../pages/ai-replay/ai-replay.module": [
		872,
		86
	],
	"../pages/all-modules/all-modules.module": [
		873,
		85
	],
	"../pages/auto-ai/auto-ai.module": [
		874,
		84
	],
	"../pages/auto-setting/auto-setting.module": [
		875,
		83
	],
	"../pages/auto/auto.module": [
		876,
		82
	],
	"../pages/backlist/add-black/add-black.module": [
		877,
		81
	],
	"../pages/backlist/backlist.module": [
		878,
		80
	],
	"../pages/baike/baike.module": [
		879,
		79
	],
	"../pages/change-img/change-img.module": [
		880,
		78
	],
	"../pages/change-roomowner/change-roomowner.module": [
		881,
		77
	],
	"../pages/chatroom-detail/chatroom-detail.module": [
		882,
		76
	],
	"../pages/chatroom/chatroom.module": [
		883,
		75
	],
	"../pages/choose-chatroom/choose-chatroom.module": [
		375
	],
	"../pages/choose-material/choose-material.module": [
		376
	],
	"../pages/contact/contact.module": [
		884,
		74
	],
	"../pages/create-send/create-send.module": [
		885,
		73
	],
	"../pages/earn-zidou-together-home/earn-zidou-together-home.module": [
		886,
		72
	],
	"../pages/earn-zidou-together-poster/earn-zidou-together-poster.module": [
		888,
		71
	],
	"../pages/earn-zidou-together/earn-zidou-together.module": [
		887,
		70
	],
	"../pages/employee/employee.module": [
		889,
		69
	],
	"../pages/employee/staff-create/staff-create.module": [
		890,
		68
	],
	"../pages/employee/staff-role-create/staff-role-create.module": [
		892,
		67
	],
	"../pages/employee/staff-role/staff-role.module": [
		891,
		66
	],
	"../pages/employee/staff/staff.module": [
		893,
		65
	],
	"../pages/essence-preview/essence-preview.module": [
		894,
		64
	],
	"../pages/essence-record/essence-record.module": [
		895,
		63
	],
	"../pages/essence-share/essence-share.module": [
		897,
		62
	],
	"../pages/essence/essence.module": [
		896,
		61
	],
	"../pages/exchange-notice/exchange-notice.module": [
		899,
		60
	],
	"../pages/forbidden/forbidden.module": [
		898,
		2
	],
	"../pages/group/group.module": [
		901,
		59
	],
	"../pages/home/home.module": [
		900,
		4
	],
	"../pages/large-img/large-img.module": [
		902,
		58
	],
	"../pages/link/link-create/link-create.module": [
		903,
		57
	],
	"../pages/link/link-detail/link-detail.module": [
		904,
		56
	],
	"../pages/link/link.module": [
		906,
		55
	],
	"../pages/my-alert/my-alert.module": [
		905,
		54
	],
	"../pages/new-home/new-home.module": [
		908,
		3
	],
	"../pages/notification-detail/notification-detail.module": [
		907,
		53
	],
	"../pages/notification-list/notification-list.module": [
		909,
		52
	],
	"../pages/official-data-setting/official-data-setting.module": [
		910,
		51
	],
	"../pages/official-data/official-data.module": [
		911,
		50
	],
	"../pages/pay-record/pay-record.module": [
		912,
		49
	],
	"../pages/permanent-qr/permanent-qr-edit/permanent-qr-edit.module": [
		377
	],
	"../pages/permanent-qr/permanent-qr-home/permanent-qr-home.module": [
		913,
		48
	],
	"../pages/permanent-qr/permanent-qr-type/permanent-qr-type.module": [
		914,
		47
	],
	"../pages/photoclip/photoclip.module": [
		378
	],
	"../pages/pull/pull-detail/pull-detail.module": [
		379
	],
	"../pages/pull/pull-group-qr/pull-group-qr.module": [
		915,
		46
	],
	"../pages/pull/pull-home/pull-home.module": [
		916,
		45
	],
	"../pages/pull/pull-manage-home/pull-manage-home.module": [
		917,
		44
	],
	"../pages/pull/pull-new/pull-new.module": [
		380
	],
	"../pages/real-time-quotes/real-time-quotes.module": [
		919,
		43
	],
	"../pages/remove-chatroom/remove-chatroom.module": [
		918,
		42
	],
	"../pages/renewal-agreement/renewal-agreement.module": [
		920,
		41
	],
	"../pages/robot/robot-list/robot-list.module": [
		921,
		40
	],
	"../pages/send/send.module": [
		923,
		39
	],
	"../pages/send/task-detail/task-detail.module": [
		922,
		38
	],
	"../pages/sensitive/sc-sensitive-msg/sc-sensitive-msg.module": [
		924,
		37
	],
	"../pages/sensitive/sensitive-edit/sensitive-edit.module": [
		925,
		36
	],
	"../pages/sensitive/sensitive-list/sensitive-list.module": [
		926,
		35
	],
	"../pages/sensitive/sensitive-msg/sensitive-msg.module": [
		927,
		34
	],
	"../pages/sensitive/sensitive-step-1/sensitive-step-1.module": [
		381
	],
	"../pages/sensitive/sensitive-step-2/sensitive-step-2.module": [
		382
	],
	"../pages/sign-chatroom/sign-chatroom.module": [
		929,
		33
	],
	"../pages/sign-member/sign-member.module": [
		928,
		32
	],
	"../pages/sign-setting/sign-setting.module": [
		930,
		31
	],
	"../pages/sign-switch/sign-switch.module": [
		931,
		30
	],
	"../pages/sign-tip/sign-tip.module": [
		933,
		29
	],
	"../pages/sign/sign.module": [
		932,
		28
	],
	"../pages/speak-setting/speak-setting-detail/speak-setting-detail.module": [
		934,
		27
	],
	"../pages/speak-setting/speak-setting.module": [
		935,
		26
	],
	"../pages/support/sc-support-main/sc-support-main.module": [
		936,
		0
	],
	"../pages/support/support-detail/support-detail.module": [
		937,
		25
	],
	"../pages/support/support-main/support-main.module": [
		868,
		1
	],
	"../pages/support/support-record-content/support-record-content.module": [
		938,
		24
	],
	"../pages/support/support-search/support-search.module": [
		939,
		23
	],
	"../pages/support/support-staff/support-staff.module": [
		940,
		22
	],
	"../pages/task-chatroom/task-chatroom.module": [
		941,
		21
	],
	"../pages/text-editer/text-editer.module": [
		383
	],
	"../pages/user-agreement/user-agreement.module": [
		942,
		20
	],
	"../pages/video-player/video-player.module": [
		384
	],
	"../pages/vip/vip-intro/vip-intro.module": [
		943,
		19
	],
	"../pages/vip/vip.module": [
		944,
		18
	],
	"../pages/wallet-detail/wallet-detail.module": [
		945,
		17
	],
	"../pages/wallet-export/wallet-export.module": [
		946,
		16
	],
	"../pages/wallet-search/wallet-search.module": [
		947,
		15
	],
	"../pages/wallet/wallet.module": [
		949,
		14
	],
	"../pages/welcome-setting/welcome-setting.module": [
		948,
		13
	],
	"../pages/welcome-ver2/welcome-ver2-edit/welcome-ver2-edit.module": [
		950,
		12
	],
	"../pages/welcome-ver2/welcome-ver2-home/welcome-ver2-home.module": [
		951,
		11
	],
	"../pages/welcome-ver2/welcome-ver2-type/welcome-ver2-type.module": [
		952,
		10
	],
	"../pages/welcome/welcome.module": [
		953,
		9
	],
	"../pages/word/word-record/word-record.module": [
		954,
		8
	],
	"../pages/word/word.module": [
		955,
		7
	],
	"../pages/zone/zone-result/zone-result.module": [
		957,
		6
	],
	"../pages/zone/zone.module": [
		956,
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 259;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 259
// module chunks = 90